var _path, _rect, _rect2, _rect3, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _rect4, _path11, _rect5, _rect6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 54,
    viewBox: "0 0 58 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M1 9C1 6.79086 2.79086 5 5 5H53C55.2091 5 57 6.79086 57 9V17H1V9Z",
    fill: "#5883C2"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.75,
    x: 9,
    y: 35,
    width: 10,
    height: 10,
    rx: 1,
    fill: "#5883C2"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.75,
    x: 19,
    y: 35,
    width: 10,
    height: 10,
    rx: 1,
    fill: "#5883C2"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 25,
    width: 10,
    height: 10,
    rx: 1,
    fill: "#2A5C96"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.2 6.04082H5.8C3.6645 6.04082 1.93333 7.86823 1.93333 10.1224V47.8776C1.93333 50.1318 3.6645 51.9592 5.8 51.9592H45.4771C46.0239 51.9592 46.5469 51.7353 46.9243 51.3396L55.5139 42.3346C55.8687 41.9626 56.0667 41.4758 56.0667 40.9617C56.0667 35.7221 56.0667 10.1224 56.0667 10.1224C56.0667 7.86823 54.3355 6.04082 52.2 6.04082ZM5.8 4C2.59675 4 0 6.74111 0 10.1224V47.8776C0 51.2589 2.59675 54 5.8 54H46.4434C46.9904 54 47.5136 53.7759 47.891 53.38L57.4476 43.355C57.8022 42.983 58 42.4888 58 41.975V10.1224C58 6.74111 55.4032 4 52.2 4H5.8Z",
    fill: "#2A5C96"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.4651 41.2054C51.7819 40.774 49.5222 40.8501 47.1751 43.1059C44.8492 45.3414 44.7641 47.6028 45.2149 49.3359C45.447 50.2283 45.8277 50.9917 46.1555 51.5358C46.3183 51.806 46.4651 52.0173 46.5686 52.158C46.6202 52.2282 46.6608 52.2804 46.6869 52.3132C46.7 52.3296 46.7093 52.3411 46.7146 52.3475L46.7188 52.3525L46.7183 52.3519C46.718 52.3516 46.7177 52.3513 45.9563 52.9995C45.1948 53.6477 45.1945 53.6473 45.1941 53.6469L45.1933 53.6459L45.1914 53.6437L45.1863 53.6376L45.1711 53.6193C45.1588 53.6043 45.1422 53.584 45.1219 53.5584C45.0812 53.5073 45.0252 53.4351 44.9578 53.3434C44.823 53.1603 44.6411 52.8977 44.4423 52.5677C44.0469 51.9114 43.5731 50.9688 43.2793 49.8394C42.6783 47.5289 42.8562 44.483 45.7892 41.6639C48.7012 38.8652 51.7005 38.6885 53.9616 39.268C55.067 39.5514 55.9797 40.0088 56.6134 40.3917C56.9319 40.5841 57.1844 40.7603 57.3605 40.8913C57.4487 40.9568 57.5181 41.0113 57.5675 41.0511C57.5922 41.0709 57.6118 41.0872 57.6264 41.0994L57.6443 41.1145L57.6504 41.1196L57.6527 41.1216L57.6536 41.1224C57.654 41.1228 57.6545 41.1231 57.0002 41.8795C56.346 42.6358 56.3464 42.6361 56.3467 42.6364L56.3473 42.6369L56.3482 42.6376L56.3436 42.6338C56.3379 42.629 56.3274 42.6203 56.3123 42.6081C56.282 42.5838 56.2333 42.5454 56.1675 42.4964C56.0355 42.3983 55.836 42.2587 55.5792 42.1036C55.0626 41.7914 54.3318 41.4276 53.4651 41.2054ZM46.7194 52.3532C46.7197 52.3536 46.7197 52.3536 46.7194 52.3532L46.7194 52.3532Z",
    fill: "#2A5C96"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 26V34H18V26H10ZM9 24C8.44772 24 8 24.4477 8 25V36H20V24H9Z",
    fill: "#2A5C96"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28 26H20V34H28V26ZM18 24V36H30V24H18Z",
    fill: "#2A5C96"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38 26H30V34H38V26ZM28 24V36H40V24H28Z",
    fill: "#2A5C96"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48 26H40V34H48V26ZM38 24V36H49C49.5523 36 50 35.5523 50 35V25C50 24.4477 49.5523 24 49 24H38Z",
    fill: "#2A5C96"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 36H10V44H18V36ZM8 34V45C8 45.5523 8.44772 46 9 46H20V34H8Z",
    fill: "#2A5C96"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28 36H20V44H28V36ZM18 34V46H30V34H18Z",
    fill: "#2A5C96"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38 36H30V44H38V36ZM28 34V46H39C39.5523 46 40 45.5523 40 45V34H28Z",
    fill: "#2A5C96"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    y: 16,
    width: 57,
    height: 2,
    fill: "#2A5C96"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M33.0503 30.9913L32 30.0002L31.0464 30.9913L32.5735 32.4779C32.705 32.6145 32.8777 32.6832 33.0503 32.6832C33.223 32.6832 33.3956 32.6145 33.5271 32.4779L36.9536 28.9911L36 28L33.0503 30.9913Z",
    fill: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    width: 4,
    height: 10,
    rx: 2,
    fill: "#2A5C96"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    width: 4,
    height: 10,
    rx: 2,
    fill: "#2A5C96"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.2e399563ce7f5c7b5c0beed383b8b8db.svg";
export { ForwardRef as ReactComponent };